export default __webpack_public_path__ + "static/img/vogue_scene_animated_0731.b7883e8.jpg";